<div class="flex items-center px-10 py-4 border-2 rounded-md gap-2" [ngClass]="hasError() ? 'border-red-500' : 'border-gray-900/10'">
    <div class="text-lg font-semibold">
        {{ title() }}
    </div>
    <mat-checkbox
        class="relative top-[3px]"
        [checked]="value()"
        (change)="onCheckedChange($event.checked)"
        [disabled]="isDisabled()"
    ></mat-checkbox>
</div>
